import React, { useContext, useState } from 'react';

const ModalContext = React.createContext();

export function useModal() {
  return useContext(ModalContext);
}

export function ModalProvider({ children }) {
  const [activeModal, setActiveModal] = useState(null);
  const [modalParams, setModalParams] = useState(null);
  const [closable, setClosable] = useState(true);

  function openModal(modal, params) {
    setActiveModal(modal);
    if (params) {
      setModalParams(params);
    }
  }

  function setParams(params) {
    setModalParams(params);
  }

  function closeModal() {
    setActiveModal(null);
    setModalParams(null);
  }
  const value = {
    activeModal,
    isModalOpen: activeModal !== null,
    modalParams,
    closable,
    openModal,
    closeModal,
    setClosable,
    setParams,
  };

  return (
    <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
  );
}
